import { render, staticRenderFns } from "./buyOrder.vue?vue&type=template&id=64b8de0c&scoped=true"
import script from "./buyOrder.vue?vue&type=script&lang=js"
export * from "./buyOrder.vue?vue&type=script&lang=js"
import style0 from "./buyOrder.vue?vue&type=style&index=0&id=64b8de0c&prod&lang=scss"
import style1 from "./buyOrder.vue?vue&type=style&index=1&id=64b8de0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8de0c",
  null
  
)

export default component.exports